<div class="row">
    <div class="col-lg-12">
        <div id="content-header" class="clearfix">
            <div class="pull-left">
                <ol class="breadcrumb">
                    <li><a href="javascript:void(0)" (click)="$state.go('missioncontrol.dashboard', {}, {reload: true})">Home</a></li>
                    <li><a href="javascript:void(0)" (click)="$state.go('missioncontrol.candidates', {}, {reload: true})"><span>Candidates</span></a></li>
                    <li class="active">Candidate Profile</li>
                </ol>
                <h1 class="heading-css">Candidate Profile</h1>
            </div>
        </div>
    </div>
</div>
<div class="row">
    <div class="col-xs-12">
        <app-candidate-profile [candidateId]="candidateId"></app-candidate-profile>
    </div>
</div>
